module.exports = __webpack_public_path__ + "img/03.fca32996.png";